import type { ButtonBlock } from './types';

export const BUTTON_LAYOUT_CSS = {
  mobileFull: 'email-btn-mobile-full',
  link: 'email-btn-link',
} as const;

export function buttonUsesMobileFullWidth(
  block: Pick<ButtonBlock, 'fullWidth' | 'fullWidthMobile'>,
): boolean {
  return !block.fullWidth && block.fullWidthMobile;
}

export function buttonInnerTableClass(
  block: Pick<ButtonBlock, 'fullWidth' | 'fullWidthMobile'>,
): string | undefined {
  return buttonUsesMobileFullWidth(block) ? BUTTON_LAYOUT_CSS.mobileFull : undefined;
}
